import {NodeFormBuilder} from '../../../../../../../shared/models';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {required, pattern} from '../../../../../../../shared/utils';
import {newStepValue} from '../../../../../services/flowBuilder/utils/constants';

export const NODE_TYPE = 'verifyOptOut';

/** The VerifyOptOutForm.
* It is the flattened version of the step.
* It should contain all the fields that can be changed by the flow-builder.
*/
export interface VerifyOptOutForm {
    name: string;
    description: string;
    numbers: string;
    fromNumber: string;
    channel: string;
    error: string;
    yes: string;
    no: string;
}

export enum OptOutChannel {
    SMS = 'SMS',
    WHATSAPP = 'WHATSAPP'
}

export class VerifyOptOut extends NodeFormBuilder<VerifyOptOutForm> {

    /**
     * NodeFormBuilder will set up the correct step type.
     */
    constructor() {
        super('action', NODE_TYPE);
    }

    /**
     * Takes in stepData and returns the flattened version

     * @return VerifyOptOutForm
     * @param stepData
     */
    getFromData(stepData: { [index: string]: any }): VerifyOptOutForm {

        const action = stepData?.action ? stepData.action : {};
        const actionParams = action?.actionParams ? action.actionParams : {};
        return {
            name: action?.name ? action.name : '',
            description: action?.description ? action.description : '',
            fromNumber: actionParams?.fromNumber ? actionParams?.fromNumber : null,
            numbers: actionParams?.numbers ? actionParams.numbers : '',
            channel: actionParams?.channel ? actionParams.channel : '',
            yes: action?.result && action?.result.yes ? action?.result.yes : newStepValue,
            no: action?.result && action?.result.no ? action?.result.no : newStepValue,
            error: action?.result && action?.result.error ? action?.result.error : newStepValue,
        };
    }

    /**
     * Constructs a FormGroup using the passed in FoobarForm
     * Only users with the correct roll is allowed to edit a flow so fields will be locked.
     *
     * @return FormGroup
     * @param nodeData
     * @param editFlows
     */
    buildForm(nodeData: VerifyOptOutForm, editFlows: boolean): UntypedFormGroup {

        return new UntypedFormGroup({
            name: new UntypedFormControl({
                value: nodeData.name,
                disabled: !editFlows
            }, required('Name')),
            description: new UntypedFormControl({
                value: nodeData.description,
                disabled: !editFlows
            }, required('Description')),
            fromNumber: new UntypedFormControl({
                value: nodeData.fromNumber,
                disabled: !editFlows
            }),
            channel: new UntypedFormControl(
                {
                    value: nodeData.channel || '',
                    disabled: !editFlows,
                }, [required('channel', 'Select a channel'),  pattern(/^(SMS|WHATSAPP)$/, 'Select a channel')]
            ),
            yes: new UntypedFormControl(nodeData.yes),
            no: new UntypedFormControl(nodeData.no),
            error: new UntypedFormControl(nodeData.error),
            numbers: new UntypedFormControl({
                value: nodeData.numbers,
                disabled: !editFlows
            }, required('Number'))
        });
    }

    /**
     * Reconstructs the step from the passed in VerifyOptOutForm
     *
     * @param nodeData
     */
    setNodeData(nodeData: VerifyOptOutForm) {

        const {name, description, numbers, yes, no, error, fromNumber, channel} = nodeData;
        this.action = {
            ...this.action,
            name,
            description,
            actionParams: {
                numbers,
                fromNumber,
                channel
            },
            result: {
                yes: yes,
                no: no,
                error: error
            }
        };

    }

}
